import { AppSessionService } from '@shared/common/session/app-session.service';
import { PermissionCheckerService } from 'abp-ng2-module';
import {
  Injector,
  ElementRef,
  Component,
  OnInit,
  ViewEncapsulation,
  Inject,
  Renderer2,
  AfterViewInit,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppMenu } from './app-menu';
import { AppNavigationService } from './app-navigation.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MenuOptions } from '@metronic/app/core/_base/layout/directives/menu.directive';
import { FormattedStringValueExtracter } from '@shared/helpers/FormattedStringValueExtracter';
import * as objectPath from 'object-path';
import { ProjectService } from '@app/main/resourcesAllocation/projects/project.service';
import { AppConsts } from '@shared/AppConsts';

@Component({
  templateUrl: './side-bar-menu.component.html',
  selector: 'side-bar-menu',
  styleUrls: ['./side-bar-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SideBarMenuComponent
  extends AppComponentBase
  implements OnInit, AfterViewInit {
  menu: AppMenu = null;

  projectId: string;
  currentRouteUrl = '';
  insideTm: any;
  outsideTm: any;

  menuOptions: MenuOptions = {
    submenu: {
      desktop: {
        default: 'dropdown',
      },
      tablet: 'accordion',
      mobile: 'accordion',
    },

    accordion: {
      expandAll: false,
    },
  };

  constructor(
    injector: Injector,
    private el: ElementRef,
    private router: Router,
    public permission: PermissionCheckerService,
    private _appNavigationService: AppNavigationService,
    private render: Renderer2,
    private _projectService: ProjectService,
    private cdr: ChangeDetectorRef,
    private _appSessionService : AppSessionService
  ) {
    super(injector);
  }

  ngOnInit() {
    (async ()=> {
      this.menu = await this._appNavigationService.getMenu();

      this.currentRouteUrl = this.router.url.split(/[?#]/)[0];

      this.projectId = await this._projectService.getCurrentOrDefaultProjectId();

      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(
          (event) => (this.currentRouteUrl = this.router.url.split(/[?#]/)[0])
        );
      this.cdr.detectChanges();
    } )()
  }

  get showManage(): Boolean{
    if(this.projectId && this._appSessionService.isAdmin){
      return true;
    }else{
      return false;
    }
  }

  ngAfterViewInit(): void {
    this.scrollToCurrentMenuElement();
  }

  showMenuItem(menuItem): boolean {
    return this._appNavigationService.showMenuItem(menuItem);
  }

  isMenuItemIsActive(item): boolean {
    if (item.items.length) {
      return this.isMenuRootItemIsActive(item);
    }

    if (!item.route) {
      return false;
    }

    let urlTree = this.router.parseUrl(this.currentRouteUrl.replace(/\/$/, ''));
    let urlString =
      '/' +
      urlTree.root.children.primary.segments
        .map((segment) => segment.path)
        .join('/');
    let exactMatch = urlString.includes(item.route.replace(/\/$/, ''));
    if (!exactMatch && item.routeTemplates) {
      for (let i = 0; i < item.routeTemplates.length; i++) {
        let result = new FormattedStringValueExtracter().Extract(
          urlString,
          item.routeTemplates[i]
        );
        if (result.IsMatch) {
          return true;
        }
      }
    }
    return exactMatch;
  }
  defaultLogo =
    AppConsts.appBaseUrl + '/assets/common/images/app-logo-on-light.svg';
  remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;
  
  //this is a hack for closing drawer after menu item clicked on mobile devices
  closeAsideMenuAfterLinkClicked() {
    if (
      document.getElementsByClassName('aside-overlay').length &&
      KTUtil.isMobileDevice()
    ) {
      document
        .getElementsByClassName('aside-overlay')[0]
        .dispatchEvent(new MouseEvent('click', { bubbles: true }));
    }
  }

  isMenuRootItemIsActive(item): boolean {
    let result = false;

    for (const subItem of item.items) {
      result = this.isMenuItemIsActive(subItem);
      if (result) {
        return true;
      }
    }

    return false;
  }

  scrollToCurrentMenuElement(): void {
    const path = location.pathname;
    const menuItem = document.querySelector("a[href='" + path + "']");
    if (menuItem) {
      menuItem.scrollIntoView({ block: 'center' });
    }
  }

  getItemAttrSubmenuToggle(item) {
    let toggle = 'hover';
    if (objectPath.get(item, 'toggle') === 'click') {
      toggle = 'click';
    } else if (objectPath.get(item, 'submenu.type') === 'tabs') {
      toggle = 'tabs';
    } else {
      // submenu toggle default to 'hover'
    }

    return toggle;
  }

  getItemCssClasses(item) {
    let classes = 'menu-item menu-item-open';

    if (objectPath.get(item, 'submenu')) {
      classes += ' menu-item-submenu';
    }

    if (!item.items && this.isMenuItemIsActive(item)) {
      classes += ' menu-item-active menu-item-here';
    }

    if (item.items && this.isMenuItemIsActive(item)) {
      classes += ' menu-item-open menu-item-here';
    }

    // custom class for menu item
    const customClass = objectPath.get(item, 'custom-class');
    if (customClass) {
      classes += ' ' + customClass;
    }

    if (objectPath.get(item, 'icon-only')) {
      classes += ' menu-item-icon-only';
    }

    return classes;
  }

  async gotToManage(){
    await this._projectService.removeCurrentProjectAsync();
    (window as any).location.href = '/app/main/dashboard';
  }
}
